import React from 'react';
import shortid from 'shortid';
import { Button } from 'components/ui/form';
import styles from './actions.module.scss';

const Actions = ({
  exportText = 'Экспорт заявок',
  importText = 'Импорт заявок',
  onExport,
  onImport,
}) => {
  const isFunction = fn => typeof fn === 'function';
  const onExportList = (Array.isArray(onExport) ? onExport : [onExport]).filter(isFunction);
  const onImportList = (Array.isArray(onImport) ? onImport : [onImport]).filter(isFunction);

  return (
    onExportList.length || onImportList.length ? (
      <div className={styles.actions}>
        {onExportList.length ? (
          onExportList.map((callback, index) => (
            <div key={shortid.generate()} className={styles.action}>
              <Button onClick={callback}>
                {Array.isArray(exportText) ? exportText[index] : exportText}
              </Button>
            </div>
          ))
        ) : null}
        {onImportList.length ? (
          onImportList.map((callback, index) => (
            <div key={shortid.generate()} className={styles.action}>
              <form onChange={callback}>
                <Button className={styles.import}>
                  <label htmlFor={`import-${index}`} className={styles.import} />
                  {Array.isArray(importText) ? importText[index] : importText}
                  <input id={`import-${index}`} name="import" type="file" accept=".xml" />
                </Button>
              </form>
            </div>
          ))
        ) : null}
      </div>
    ) : null
  );
};

export default Actions;
